import React from 'react';

import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './Callout.style';

const Callout = React.memo(function Callout({ variant = 'default', title, children, ariaLabel }) {
  // Generate unique ID for accessibility
  const headingId = `callout-heading-${React.useId()}`;

  return (
    <Box
      aria-label={title ? undefined : ariaLabel}
      aria-labelledby={title ? headingId : undefined}
      component="aside"
      role="complementary"
    >
      <Styled.Callout>
        <Styled.Bar variant={variant} />
        <Styled.Content spacing={0.5}>
          {title && (
            <Text color="primary" id={headingId} size="md" weight="medium">
              <FormattedMessage id={title} />
            </Text>
          )}
          {children}
        </Styled.Content>
      </Styled.Callout>
    </Box>
  );
});

Callout.propTypes = {
  variant: PropTypes.oneOf(['default', 'info', 'success', 'warning', 'error']),
  title: PropTypes.node,
  children: PropTypes.node,
  ariaLabel: PropTypes.string,
};

export default Callout;
